import { render } from "./ProductDataTable.vue?vue&type=template&id=9cd7b88e&scoped=true"
import script from "./ProductDataTable.vue?vue&type=script&lang=js"
export * from "./ProductDataTable.vue?vue&type=script&lang=js"

import "./ProductDataTable.vue?vue&type=style&index=0&id=9cd7b88e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd7b88e"]])

export default __exports__